


























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
  },
})
export default class ImgViewModal extends Vue {
    @Prop({required: false, default: 'Afbeelding'})
    public title!: string;

    private url: string = '';
    private visible: boolean = false;
    private fullScreen: boolean = false;

    public show(url: string) {
        this.url = url;
        this.visible = true;
    }

    public hide() {
        this.visible = false;
    }

    private toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
    }
}
